import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ServiceService {
    services;

    constructor(private http: HttpClient) {
    }

    createService(body) {
        return this.http.post(`${environment.apiUrl}/service`, body);
    }

    getService(id: string) {
        return this.http.get(`${environment.apiUrl}/service/${id}`).pipe(map(({ service }: any) => service));
    }

    initServices() {
        if (this.services?.length) return;
        return this.http.get(`${environment.apiUrl}/services`).pipe(map(({ list }: any) => (this.services = list)));
    }

    updateService(body) {
        return this.http.put(`${environment.apiUrl}/service`, body);
    }
}
